import { portal } from '../Configs/general';

// * RECAPTCHA ACTIONS
// Máximo 32 caracteres, por limitación de Cloudflare Turnstile.

export const RecaptchaAction = {
  AssociateContract: `${portal}_assoc_contract`,
  AssociateContractGetChallenge: `${portal}_assoc_get_chal`,
  AssociateContractCheckChallenge: `${portal}_assoc_check_chal`,
  Login: `${portal}_login`,
  RecoverPassword: `${portal}_recover_pwd`,
  ValidatePartialPayments: `${portal}_pay_validate_part`,
  CheckPartialPayments: `${portal}_pay_check_part`,
  PartialCouponPayments: `${portal}_pay_gen_part_coupon`,
  PeriodicRevisionHistory: `${portal}_pr_history`,
  PeriodicRevisionRequest: `${portal}_pr_request`,
  PeriodicRevisionAgenda: `${portal}_pr_agenda`,
  PeriodicRevisionOrderInfo: `${portal}_pr_order_info`,
  PeriodicRevisionSchedule: `${portal}_pr_schedule`,
  PeriodicRevisionUpdateSchedule: `${portal}_pr_update_sched`,
  PeriodicRevisionCancelSchedule: `${portal}_pr_cancel_sched`,
  VerifyPhoneCode: `${portal}_phone_verify_code`,
  FetchBulkInvoices: `${portal}_inv_fetch_bulk`,
  ChangeOwnershipGetRequest: `${portal}_own_get_req`,
  ChangeOwnershipCreateRequest: `${portal}_own_create_req`,
  BrebPendingQr: `${portal}_breb_pending_qr`
};
